<template>
  <div
    :class="[{'items-center': itemsCenter},'table-row']"
    :style="{'grid-template-columns': columnTemplates, 'background-color': bgRow}"
    @click="getData">
  <slot></slot>
  </div>
</template>

<script>
export default {
  name: "BaseTableRow",
  props: {
    idx: {
      type: Number, String
    },
    itemsCenter: {
      type: Boolean,
      required: false
    },
    columnTemplates: {
      type: String,
      required: false
    },
    bgRow: {
      type: String,
      required: false
    }
  },
  methods: {
    getData() {
      this.$emit('getRowData')
    }
  }
}
</script>

<style lang="scss" scoped>
.items-center {
  justify-items: center;
}
.table-row {
  border-bottom: 2px solid #EEEFF4;
  position: relative;
  display: grid;
  column-gap: 10px;
  align-items: center;
  padding: 0 16px;
  &:last-child {
    border-bottom: none;
  }
}
</style>
